import { Clock, Mail, Settings, PhoneCall } from "lucide-react";

const SectionContactInfo = () => {
  const contactInfo = [
    {
      icon: <PhoneCall size={28} className="text-red-600" />,
      title: "Hotline Tư vấn Giải pháp",
      content: "0822 041 909",
      subtitle: "Tư vấn dịch vụ & báo giá 24/7",
    },
    {
      icon: <Settings size={28} className="text-red-600" />,
      title: "Hỗ trợ Kỹ thuật & Vận hành",
      content: "0822 041 909",
      subtitle: "Hỗ trợ hệ thống, bảo trì Web/App/CRM",
    },
    {
      icon: <Mail size={28} className="text-red-600" />,
      title: "Email Tiếp nhận Yêu cầu",
      content: "info@triocoresolutions.com",
      subtitle: "Phản hồi giải pháp sơ bộ trong vòng 2 giờ",
    },
    {
      icon: <Clock size={28} className="text-red-600" />,
      title: "Giờ làm việc",
      content: "Thứ 2 - Thứ 6: 8:00 - 17:30",
      subtitle: "Thứ 7: 8:00 - 12:00 | Chủ nhật: Nghỉ",
    },
  ];

  return (
    <section className="bg-[linear-gradient(180deg,#ffffff_0%,#fff8f8_100%)] py-16">
      <div className="container">
        <div className="mx-auto mb-12 max-w-[760px] text-center">
          <h2 className="text-[28px] font-semibold text-[#2f1a1a] sm:text-[34px]">Thông tin liên hệ</h2>
          <p className="mx-auto mt-4 max-w-[680px] text-[15px] leading-8 text-slate-600">
            Các đầu mối liên hệ được phân theo từng nhu cầu để doanh nghiệp kết nối đúng bộ phận phụ
            trách, rút ngắn thời gian trao đổi và nhận tư vấn chính xác hơn.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mb-14">
          {contactInfo.map((item) => (
            <div key={item.title} className="h-full rounded-[22px] border border-red-100 bg-white shadow-[0_16px_34px_rgba(127,29,29,0.06)] p-6">
              <div className="text-left">
                <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-2xl bg-red-50">
                  {item.icon}
                </div>
                <h3 className="text-[18px] font-semibold text-[#2f1a1a]">{item.title}</h3>
                <p className="mt-3 text-[17px] font-semibold text-red-600">{item.content}</p>
                <p className="mt-2 text-[14px] leading-7 text-slate-600">{item.subtitle}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="rounded-[24px] border border-red-100 bg-white px-6 py-8 shadow-[0_18px_38px_rgba(127,29,29,0.06)] sm:px-8">
          <h3 className="text-[24px] font-semibold text-[#2f1a1a]">Cam kết phản hồi chuyên nghiệp</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
            <div>
              <div className="text-3xl font-semibold text-red-600">24/7</div>
              <p className="mt-2 text-[14px] leading-7 text-slate-600">Tiếp nhận tư vấn và nhu cầu báo giá.</p>
            </div>
            <div>
              <div className="text-3xl font-semibold text-red-600">2 giờ</div>
              <p className="mt-2 text-[14px] leading-7 text-slate-600">
                Phản hồi sơ bộ qua email cho các yêu cầu phù hợp.
              </p>
            </div>
            <div>
              <div className="text-3xl font-semibold text-red-600">24 - 48h</div>
              <p className="mt-2 text-[14px] leading-7 text-slate-600">
                Gửi định hướng giải pháp và báo giá chi tiết sau khảo sát.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionContactInfo;
